module.exports = __webpack_public_path__ + "assets/8af3a6b9c9ca8adbb005d29e0af07268.png";